import { jsx as _jsx } from "react/jsx-runtime";
import { Text } from '../../../components/text/text';
/**
 * @description
 * OptionLabelSlice component is used to render the label of an option.
 * @param {React.PropsWithChildren<IOptionSlice>} props
 * @returns {JSX.Element | null}
 * @constructor
 */
export const OptionLabelSlice = ({ variant, color, weight, decoration, component, dataTestId, children, }) => {
    if (!children) {
        return null;
    }
    return (_jsx(Text, { color: color, component: component, dataTestId: dataTestId, decoration: decoration, variant: variant, weight: weight, children: children }));
};
//# sourceMappingURL=optionLabelSlice.js.map